module.exports = __webpack_public_path__ + "static/media/default.b2295297.svg";